<script lang="ts">
  import { _ } from 'svelte-i18n';
  import RequirementTable from './RequirementTable.svelte';

  /* eslint-disable @typescript-eslint/no-explicit-any */
  // The rows of a plan's targets. A race has two kinds, kept apart: what the athlete can do (the signature) and the
  // training loads they are ready with; the other plan types are one table.
  export let rows: any[] = [];
  export let programType = '';
  export let actualLabel = 'Actual';
  export let projected = false;
  // A race report that draws the signature (power capability) itself leaves it out here.
  export let showCapability = true;
  export let targetLabel = 'Target';
  export let onAdapt: (() => void) | null = null;

  $: capability = rows.filter((r) => r.group === 'power_capability');
  $: loads = rows.filter((r) => r.group === 'training_load');
</script>

{#if programType === 'RACE'}
  {#if showCapability}
    <h3 class="text-sm font-medium mb-1 text-zinc-600">{$_('report.table.power_capability')}</h3>
    {#if capability.length}
      <RequirementTable rows={capability} {actualLabel} {projected} {targetLabel} />
    {:else}
      <p class="text-sm text-zinc-500 mb-3">{$_('report.table.not_assessed')}</p>
    {/if}
  {/if}
  <h3 class="text-sm font-medium {showCapability ? 'mt-4' : ''} mb-1 text-zinc-600">{$_('report.table.load_readiness')}</h3>
  <RequirementTable rows={loads} {actualLabel} {projected} {targetLabel} {onAdapt} />
{:else}
  <RequirementTable {rows} {actualLabel} {projected} {targetLabel} {onAdapt} />
{/if}
